import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';

import { SliderContainer, Slide, ShowAll, SliderWindow, CloseModalButton, ModalSlider, ModalSlide, NavigationButton } from './styles';

class ProductGallery extends PureComponent {
  static propTypes = {
    slidesData: PropTypes.instanceOf(Object),
    hotelName: PropTypes.string,
  };

  state = {
    isOpen: false,
    isEnd: false,
    isBeginning: false,
  };

  swiperModal = null;

  swiper = null;

  params = {
    slidesPerView: 1,
    spaceBetween: 0,
    breakpointsInverse: true,
    preloadImages: false,
    lazy: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    },
  };

  modalParams = {
    slidesPerView: 1,
    watchOverflow: true,
    preloadImages: false,
    lazy: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction'
    },
    parentClass: this,
    on: {
      init () {
        this.params.parentClass.setState({
          isEnd: this.isEnd,
          isBeginning: this.isBeginning,
        })
      },
      transitionStart () {
        this.params.parentClass.setState({
          isEnd: this.isEnd,
          isBeginning: this.isBeginning,
        })
      },
    }
  };

  componentDidUpdate(prevProps) {
    const { slidesData: prevPhotos } = prevProps;
    const { slidesData: newPhotos } = this.props;

    if (JSON.stringify(prevPhotos) !== JSON.stringify(newPhotos)) {
      Array.from(this.swiper.slides).forEach(slide => {
        slide.querySelector('img').setAttribute('src', '');
        slide.querySelector('img').classList.remove('swiper-lazy-loaded');
      });
      this.swiper.lazy.load();
    }
  }

  goNext= () => {
    if (this.swiperModal) this.swiperModal.slideNext();
  };

  goPrev= () => {
    if (this.swiperModal) this.swiperModal.slidePrev();
  };

  handleModalSliderButtonClick = () => {
    const { isOpen } = this.state;

    document.body.classList[isOpen ? 'remove' : 'add']('noscroll');

    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }))
  };

  handleSlideSelection = evt => {
    if (window && window.matchMedia('(min-width: 768px)').matches) {
      const { target } = evt;

      this.modalParams.initialSlide = Number(target.dataset.value);

      document.body.classList.add('noscroll');

      this.setState({
        isOpen: true,
      });
    }
  };

  renderModalWindow = () => {
    const { handleModalSliderButtonClick, goNext, goPrev, modalParams } = this;
    const { isOpen, isEnd, isBeginning } = this.state;
    const { slidesData, hotelName } = this.props;
    let content;

    if (isOpen) {
      content = (
        <SliderWindow>
          <CloseModalButton onClick={handleModalSliderButtonClick} />
          <ModalSlider>
            <NavigationButton onClick={goPrev} className="modal-navigation modal-navigation--prev" disabled={isBeginning} />
            <NavigationButton onClick={goNext} className="modal-navigation modal-navigation--next" disabled={isEnd} />
            <Swiper
              {...modalParams}
              ref={node => {
                if (node) this.swiperModal = node.swiper;
              }}
            >
              {slidesData.map((elem, index) => (
                <ModalSlide key={index}>
                  <div>
                    <img data-src={`${process.env.CDN_URL}${elem}`} src="" alt={hotelName} className="swiper-lazy" />
                  </div>
                </ModalSlide>
              ))}
            </Swiper>
          </ModalSlider>
        </SliderWindow>
      )
    }

    return content;
  };

  render() {
    const { handleModalSliderButtonClick, renderModalWindow, handleSlideSelection, params } = this;
    const { slidesData, hotelName } = this.props;

    const slicedImages = slidesData.slice(0, 6);

    return (
      <section>
        <SliderContainer amount={slicedImages.length}>
          <Swiper
            {...params}
            ref={node => {
              if (node) this.swiper = node.swiper;
            }}
          >
            {slicedImages.map((elem, index) => (
              <Slide key={index} amount={slicedImages.length} data-value={index} onClick={handleSlideSelection}>
                <img data-src={`${process.env.CDN_URL}${elem}`} src="" alt={hotelName} className="swiper-lazy" />
              </Slide>
            ))}
          </Swiper>
          {slicedImages.length > 1 && <ShowAll type="button" onClick={handleModalSliderButtonClick}>Show all photos</ShowAll>}
        </SliderContainer>
        {renderModalWindow()}
      </section>
    );
  }
}

export default ProductGallery;
